module.exports = __webpack_public_path__ + "img/mob2.401cbc12.png";